import { Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { LucideAngularModule } from 'lucide-angular';
import { JOURNEY_PHASE_ICONS } from 'src/app/constants/journey-gamification';
import { JourneyPhaseView } from 'src/app/shared/models/journey.models';
import { JourneyStepItemComponent } from '../journey-step-item/journey-step-item.component';

/**
 * One phase of the journey, as a collapsible panel.
 *
 * The five phases used to sit side by side, which put twenty-one checkboxes on screen at once
 * and gave the eye nowhere to land. Stacked and collapsed, only the phase in progress is open
 * — the others stay one click away, since company steps are not done in a fixed order.
 */
@Component({
  selector: 'app-journey-phase-card',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule,
    LucideAngularModule,
    JourneyStepItemComponent,
  ],
  templateUrl: './journey-phase-card.component.html',
})
export class JourneyPhaseCardComponent {
  phase = input.required<JourneyPhaseView>();
  expanded = input(false);
  pendingStepKey = input<string | null>(null);

  expandToggled = output<void>();
  stepToggled = output<string>();

  icon = computed(() => JOURNEY_PHASE_ICONS[this.phase().phase]);

  anchorId = computed(() => `journey-phase-${this.phase().phase}`);
}
